const HeroSlider = function() {
    function HeroSlider() {
        this.selector = {
            desktopvideo: document.querySelectorAll(".hero-desktop-video"),
            mobilevideo: document.querySelectorAll(".hero-mobile-video")
        }
        this.load();
    }
    HeroSlider.prototype.load = function() {
        var _ = this;
        document.addEventListener("DOMContentLoaded", async function() {       
            if(_.selector.desktopvideo.length > 0 && window.innerWidth >= 769) {      
                    _.selector.desktopvideo.forEach(el => {
                        el.src = el.dataset.videoSrc;
                    })
            }
            if(_.selector.mobilevideo.length > 0 && window.innerWidth <= 768) {
                    _.selector.mobilevideo.forEach(el => {
                        el.src = el.dataset.videoSrc;
                    })
            }
        })
        window.addEventListener("resize", function() {
            if(_.selector.desktopvideo.length > 0 && window.innerWidth >= 769) {     
                _.selector.mobilevideo.forEach(el => {
                    el.src = '';
                })         
                _.selector.desktopvideo.forEach(el => {
                    el.src = el.dataset.videoSrc;
                })
            }
            if(_.selector.mobilevideo.length > 0 && window.innerWidth <= 768) {        
                _.selector.desktopvideo.forEach(el => {
                    el.src = '';
                })      
                _.selector.mobilevideo.forEach(el => {
                    el.src = el.dataset.videoSrc;
                })
            }
        });       
    }
    HeroSlider = new HeroSlider;
}
HeroSlider();